import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
export const getStarterUpgradeProduct = ({
  productLine,
  tab
}) => {
  const isInApp = !tab;
  if (!isInApp) {
    return undefined;
  }
  const upgradeProductMaybe = productLine && UpgradeProducts[`${productLine}_STARTER`];
  return upgradeProductMaybe || UpgradeProducts.SUITE_STARTER;
};